import React, { useState } from 'react';
import axios from 'axios';

const EmailTest = () => {
	const [email, setEmail] = useState('');
	const [loading, setLoading] = useState(false);
	const [result, setResult] = useState(null);
	const [error, setError] = useState(null);

	const sendTestEmail = async (e) => {
		e.preventDefault();
		setLoading(true);
		setResult(null);
		setError(null);

		try {
			const response = await axios.post('/api/test/email', {
				toEmail: email,
			});

			setResult(response.data);
			console.log('✅ Test email sent:', response.data);
		} catch (err) {
			setError(err.response?.data?.error || err.message);
			console.error('❌ Test email failed:', err);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className='max-w-md mx-auto mt-8 p-6 bg-white rounded-lg shadow-md'>
			<h2 className='text-2xl font-bold mb-6 text-gray-800'>
				Email Service Test
			</h2>

			<form onSubmit={sendTestEmail} className='space-y-4'>
				<div>
					<label
						htmlFor='email'
						className='block text-sm font-medium text-gray-700 mb-2'>
						Test Email Address
					</label>
					<input
						type='email'
						id='email'
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						placeholder='Enter email to send test to'
						className='w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
						required
					/>
				</div>

				<button
					type='submit'
					disabled={loading || !email}
					className={`w-full py-2 px-4 rounded-md font-medium ${
						loading || !email
							? 'bg-gray-400 cursor-not-allowed'
							: 'bg-blue-600 hover:bg-blue-700'
					} text-white transition-colors`}>
					{loading ? 'Sending...' : 'Send Test Email'}
				</button>
			</form>

			{/* Success Result */}
			{result && (
				<div className='mt-4 p-4 bg-green-50 border border-green-200 rounded-md'>
					<h3 className='text-green-800 font-medium'>✅ Success!</h3>
					<p className='text-green-700 text-sm mt-1'>{result.message}</p>
					<p className='text-green-600 text-xs mt-1'>
						Service: {result.emailService}
					</p>
					{result.messageId && (
						<p className='text-green-600 text-xs mt-1'>
							Message ID: {result.messageId}
						</p>
					)}
					{result.previewUrl && (
						<div className='mt-3'>
							<p className='text-green-700 text-sm font-medium'>
								📧 Email Preview:
							</p>
							<a
								href={result.previewUrl}
								target='_blank'
								rel='noopener noreferrer'
								className='text-blue-600 hover:text-blue-800 text-sm underline'>
								View email in browser →
							</a>
							<p className='text-green-600 text-xs mt-1'>
								(Ethereal Email - test emails are not actually delivered)
							</p>
						</div>
					)}
				</div>
			)}

			{/* Error Result */}
			{error && (
				<div className='mt-4 p-4 bg-red-50 border border-red-200 rounded-md'>
					<h3 className='text-red-800 font-medium'>❌ Error</h3>
					<p className='text-red-700 text-sm mt-1'>{error}</p>
				</div>
			)}

			{/* Instructions */}
			<div className='mt-6 p-4 bg-blue-50 border border-blue-200 rounded-md'>
				<h3 className='text-blue-800 font-medium text-sm'>
					Email Service Options:
				</h3>

				<div className='mt-2 space-y-3'>
					<div>
						<h4 className='text-blue-700 text-xs font-medium'>
							🚀 Option 1: No Setup Required (Testing)
						</h4>
						<p className='text-blue-600 text-xs'>
							Uses Ethereal Email automatically - emails are not delivered but
							you get preview links to see how they look.
						</p>
					</div>

					<div>
						<h4 className='text-blue-700 text-xs font-medium'>
							📧 Option 2: Gmail SMTP (Production)
						</h4>
						<ol className='text-blue-600 text-xs mt-1 space-y-1 list-decimal list-inside ml-2'>
							<li>Set ADMIN_EMAIL environment variable (your Gmail address)</li>
							<li>
								Set ADMIN_EMAIL_PASSWORD environment variable (Gmail App
								Password)
							</li>
							<li>Enable 2FA on your Gmail account</li>
							<li>Generate an App Password in Gmail settings</li>
						</ol>
					</div>
				</div>
			</div>
		</div>
	);
};

export default EmailTest;
